var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-checkbox',{attrs:{"true-label":_vm.trueLabel,"false-label":_vm.falseLabel,"value":_vm.value},on:{"input":_vm.change}},[_vm._v(_vm._s(_vm.text ? _vm.$t(_vm.text) : ''))])}
var staticRenderFns = []

export { render, staticRenderFns }